import { message } from "antd";
import axios from "axios";
import { create } from "zustand";

export const useWarehouse = create((set, get) => ({
    warehouses: [],
    shops: [],
    editRecord: {},
    setEditRecord: (record) => set({ editRecord: record }),

    getWarehouse: () => {
        axios.get('/warehouses').then(res => {
            set({ warehouses: res.data });
        }).catch(() => {
            message.error("Skladlarni olishda xatolik yuz berdi");
        });
    },

    getShops: () => {
        axios.get('/shops').then(res => {
            set({ shops: res.data.map(s => ({ label: s.shopname, value: s.id })) });
        }).catch(() => {
            message.error("Do'konlarni olishda xatolik yuz berdi");
        });
    },

    addWarehouse: (warehouse) => {
        axios.post('/warehouses', warehouse).then(() => {
            get().getWarehouse();
            message.success("Sklad muvaffaqiyatli qo'shildi");
        }).catch(() => {
            message.error("Sklad qo'shishda xatolik yuz berdi");
        });
    },

    editWarehouse: (warehouse) => {
        axios.put(`/warehouses/${warehouse.id}`, warehouse).then(() => {
            get().getWarehouse();
            message.success("Sklad muvaffaqiyatli tahrirlandi");
        }).catch(() => {
            message.error("Skladni tahrirlashda xatolik yuz berdi");
        });
    },

    deleteWarehouse: (_, record) => {
        axios.delete(`/warehouses/${record.id}`).then(() => {
            get().getWarehouse();
            message.success("Sklad muvaffaqiyatli o'chirildi");
        }).catch(() => {
            message.error("Skladni o'chirishda xatolik yuz berdi");
        });
    },
}));